import PATH from "constants/path";
import React from "react";
import { ButtonAddPartner } from "assets/svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ERROR_MESSAGE } from "constants/global";
import ModalSubmit from "../ModalSubmit";
import ModalConfirm from "../ModalConfirm";
import ModalAddPartner from "../ModalAddPartner";
import ModalUpdatePartner from "../ModalUpdatePartner";
import ModalCanEntry from "../ModalCanEntry";
import ListPartnerPromotion from "../ListPartnerPromotion";
import { clearMessage } from "features/Promotion/promotionSlice";

const Partner = () => {
  const dispatch = useDispatch();
  // state open modal
  const [modalOpen, setModalOpen] = useState(false);
  // partner infor selected
  const [partnerInfo, setPartnerInfo] = useState(null);
  // state check promotion_set
  const [check, setCheck] = useState([]);
  const [errorCheck, setErrorCheck] = useState(null);

  // redux store
  const { promotion, promotion_set, list, flag_button } = useSelector(
    (state) => state.promotion
  );

  // close modal
  const closeModal = () => {
    setModalOpen("");
    dispatch(clearMessage());
  };

  // handle checkbox promotion set
  const handleChange = (e) => {
    // cler error when checked checkbox
    setErrorCheck(null);

    const { value, checked } = e.target;

    // check list and update list
    if (checked) {
      setCheck([...check, value]);
    } else {
      setCheck(check.filter((e) => e !== value));
    }
  };

  // check condition and open modal apply promotion
  const openModalSubmit = () => {
    if (check.length > 0 || promotion_set.length === 0 || promotion.split_flg == 0) {
      setModalOpen("modal-submit");
    } else {
      setErrorCheck(ERROR_MESSAGE.PROMOTION_SET);
    }
  };

  // default check promotion_set
  useEffect(() => {
    if (promotion.split_flg == 0 && promotion_set.length > 0) {
      setCheck([...check, ""+promotion_set[0].id]);
    }
  }, []);

  return (
    !promotion?.display_entry_flg ? (
      <>
        <div className="border-in-detail d-block d-md-none"></div>
        <div className="detail-clap my-3 my-md-4">
          {promotion.split_flg == 1 && promotion_set.length > 0 && (
            <div className="title mt-3">
              {promotion?.explain_event}
            </div>
            )
          }
          {/* DISPLAY ERROR */}
          {errorCheck && (
            <div className="alert alert-danger mt-2">{errorCheck}</div>
          )}

          {/* LIST PROMOTION SET  */}
          {flag_button && promotion_set.map((item) => {
              return (
                <div key={item.id} className="my-3 fw-600 fs-13">
                  {promotion.split_flg == 1 &&
                  <div className="bg-violet border-radius-3 px-2 px-md-3 py-2 fs-sm-12">
                    <input
                      type="checkbox"
                      className="check-clap"
                      id={item.id}
                      value={item.id}
                      onChange={handleChange}
                    />
                    {/* PROMOTION SET NAME */}
                    <label htmlFor={item.id} className="fs-16">
                      {item.name}
                    </label>
                  </div>}
                  {/* DISPLAY PARTNER OF PROMOTION SET */}
                  {promotion.partner_flg == 1 &&
                  <ListPartnerPromotion
                    list={list}
                    openFn={setModalOpen}
                    promotionset_id={item.id}
                    setPartnerInfo={setPartnerInfo}
                    partner_flg={promotion?.partner_flg}
                  />}
                </div>
              );
          })}

          {/* CHECK CONDITION PARTNER FLAG PROMOTION */}
          {promotion?.partner_flg === 1 && flag_button && (
            <>
              <div className="title my-4">
                {promotion?.explain_companion}
              </div>

              <div className="my-3">
                <div
                  className="btn-custom orange-border"
                  onClick={() => setModalOpen("modal-add-partner")}
                >
                  {/* ADD PARTNER */}
                  <span>
                    <ButtonAddPartner />
                  </span>
                  <span className="ms-3 align-middle">同行者を追加する</span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="border-in-detail"></div>

        {/* GROUP BUTTON APPLY ENTRIES */}
        <div className="group-btn-custom my-5">
          <a href={PATH.TOP} className="btn-custom after">
            戻る
          </a>
          {flag_button && 
            <a onClick={openModalSubmit} className="btn-custom red-light before">
              この案件に応募する
            </a>
          }
        </div>

        {/* MODAL */}
        <ModalSubmit
          open={modalOpen === "modal-submit"}
          openFn={setModalOpen}
          closeFn={closeModal}
          check={check}
        />

        <ModalCanEntry
          open={modalOpen === "modal-can_entry"}
          closeFn={closeModal}
        />

        <ModalConfirm
          open={modalOpen === "modal-confirm"}
          closeFn={closeModal}
          check={check}
        />

        <ModalUpdatePartner
          open={modalOpen === "modal-update-partner"}
          closeFn={closeModal}
          partnerInfo={partnerInfo}
          setPartnerInfo={setPartnerInfo}
        />

        <ModalAddPartner
          open={modalOpen === "modal-add-partner"}
          closeFn={closeModal}
        />
      </>
    ) : null
  );
};

export default Partner;
